export default (input: string): string => {
    return input
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
};



// WEBPACK FOOTER //
// ./app/bundles/appointman/app/ts/utils/encodeHTMLEntities.ts